import config from '@/config';
import { useEffect, useState } from 'react';
/**
 * React hook that returns if the application is online
 * is click outside the reference element
 *
 * @param host - Is the host to see if it's reachable
 * @return The service worker
 *
 */
export function useIsOnline(h?: string): boolean {
	const host: string = h ?? config.build.host;
	const [onlineStatus, setOnlineStatus] = useState<boolean>(navigator.onLine);
	useEffect(() => {
		const onlineHandler = () => {
			setOnlineStatus(true);
		};
		const offlineHandler = () => {
			setOnlineStatus(false);
		};

		isReachable(host)
			.then(() => {
				setOnlineStatus(true);
			})
			.catch(() => {
				setOnlineStatus(false);
			});

		window.addEventListener('online', onlineHandler);
		window.addEventListener('offline', offlineHandler);

		return () => {
			window.removeEventListener('online', onlineHandler);
			window.removeEventListener('offline', offlineHandler);
		};
	}, []);
	return onlineStatus;
}

async function isReachable(url: string) {
	const resp = await fetch(url, { method: 'HEAD', mode: 'no-cors' });
	return resp && (resp.ok || resp.type === 'opaque');
}
